module.exports = __webpack_public_path__ + "static/media/pic4.313f2205.jpg";